import React from 'react';
import { AUDIENCE } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';
import Section, { Reveal } from './Section';

export default function Audience() {
  return (
    <Section
      id="audience"
      eyebrow="Who It's For"
      title={(
        <>
          Built For The People<br />Doing The Work.
        </>
      )}
      lead="From working professionals to side-hustlers, career-shifters to buyers, SAMZ is the connective tissue that makes the U.S. creative economy actually work for the people inside it."
    >
      <div className="grid md:grid-cols-2 gap-5">
        {AUDIENCE.map((a, i) => (
          <Reveal key={a.tag} delay={i * 80}>
            <div className="card-border rounded-2xl p-8 lg:p-10 h-full flex flex-col">
              <div className="flex items-center justify-between mb-7">
                <div className="pin-num">0{i + 1} · {a.tag}</div>
                <ArrowUpRight size={18} className="text-white/30" />
              </div>
              <h3 className="font-display text-white text-[28px] md:text-[34px] leading-[1.05] tracking-[-0.03em] mb-4">
                {a.title}
              </h3>
              <p className="text-white/60 text-[14.5px] leading-[1.7]">{a.body}</p>
              <div className="mt-7">
                <a href="#signup" className="text-[#22A773] text-[12.5px] tracking-[0.14em] uppercase hover:text-[#CFA153] transition-colors inline-flex items-center gap-2">
                  Sign Up <ArrowUpRight size={14} />
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
